import { Typography } from '@mui/material'
import Link from '../navigation/Link'
import { textOperators, dateOperators } from '../../utils/constants/operators'
import { buildStatusColumn } from '../fields/StatusField'
import ListModule from '../module/ListModule'
import React, { useMemo } from 'react'

const CreditSubModule = ({ userRight, user, location, statusList }) => {
  const options = useMemo(
    () => ({
      tableStyle: { maxHeight: 350, padding: '1px' },
      paperStyle: {},
      accessRight: userRight,
      actions: { go: true },
      objectType: 'creditNotes',
      objectFilter: () => ({ customer_id: location?.state?.id, company_id: user?.company_id }),
      isFilter: true,
      isExpand: false,
      defaultSorted: 'creditNote_number',
      columns: [
        { name: 'creditNote_number', label: 'N° Avoir', isFilter: true, operators: textOperators },
        {
          display: 'invoice.invoice_number',
          name: 'invoice_number',
          label: 'N° Facture',
          isFilter: false,
          operators: textOperators,
          mapping: (id, rowid) => (
            <Typography
              state={{ id: rowid?.invoice_id, history: '/creditNotes' }}
              component={Link}
              to={`/invoices/view`}
            >
              {id}
            </Typography>
          )
        },
        {
          name: 'creditNote_date',
          label: 'Date Avoir',
          isFilter: true,
          inputType: 'date',
          type: 'date',
          format: 'DD/MM/YYYY',
          operators: dateOperators
        },
        { name: 'total_amount_net', label: 'Montant total', type: 'currency', isFilter: false },
        buildStatusColumn('creditNotes', statusList)
      ]
    }),
    [userRight, user?.company_id, location?.state?.id, statusList]
  )

  const toolbar = useMemo(
    () => ({
      isFilter: true,
      isSubMod: true,
      columns: options.columns,
      style: { marginTop: '5px', marginBottom: '5px' },
      objectType: 'creditNotes',
      accessRight: userRight,
      actions: { addFor: true },
      getContext: () => ({ customer_id: location?.state?.id }),
      columnVisibility: true
    }),
    [options.columns, userRight, location?.state?.id]
  )

  return <ListModule options={options} toolbar={toolbar} />
}

export default React.memo(CreditSubModule)
